import { ConsoleSqlOutlined, SettingFilled } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  InputProps,
  Menu,
  Pagination,
  Popover,
  Radio,
  Row,
  Select,
  Switch,
  Table,
  Tooltip,
} from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectEdition, selectTenantId } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import { GlobalKeyboardAction } from '../../../../compnents/actions/GlobalKeyboardAction'
import { Material } from '../../../../models/material'
import { FirstPage, Pager } from '../../../../models/pagination'
import { RecipeCategory } from '../../../../models/recipe'
import { Checks, Settings } from '../../../../models/setting'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { sleep } from '../../../../utils/SystemUtils'
import { useTimeout } from '../../../../utils/timehooks'
import { getAiMatchAsync } from '../../../commodity/commoditySlice'
import {
  getRecipeItemCompletions,
  getSetMealListAsync,
  ItemCompletionType,
} from '../../../completion/completionSlice'
import {
  getAcceptsType,
  getSaveSomeFunctions,
} from '../../../registration/register/registerSlice'
import { selectTreatment } from '../recipeListEditorSlice'
import {
  selectBooleanSetting,
  setSettings,
} from '../../../settings/settingsSlice'
import {
  getSettingDetail,
  selectSettings,
} from '../../../user/setting/settingSlice'
import {
  RecipeItemColumns,
  RecipeItemColumnsSimple,
  RecipeItemColumnsWithBatchNo,
  RecipeItemColumnTC,
} from './columns'
import styles from './RecipeItemInput.module.css'
import { AddCatalogueModal } from './AddCatalogueModal'
import { LoadingModal } from './LoadingModal'

export interface RecipeItemInputRef {
  focus: () => void
  select: () => void
}

interface RecipeItemInputProps {
  record?: any
  isShowPageChange?: boolean
  isShowAddcatalog?: boolean
  msfxFlag?: boolean
  searfhTcFlag?: boolean //是否搜索套餐的标志
  noSuffix?: any
  selectTag?: any
  noSetting?: any
  isRestrictUser?: any
  wbTag?: any
  type: ItemCompletionType
  category?: RecipeCategory
  storehouseId?: string
  normalGysName?: any
  filters?: boolean
  useSpecifiedBatch?: boolean
  ignoreStorage?: boolean
  includeAllTcm?: boolean
  value?: string
  onChange?: (value: string) => void
  onSelect?: (material: Material, ignoreStorage: boolean) => void
  onItems?: (v?: any) => void
  autoFocus?: boolean
  style?: React.CSSProperties
  disabled?: boolean
  insuranceCode?: string
  potionType?: number
  BScategory?: any
  categoryTag?: any
  scene?: string
  placeholder?: string
  storehouseCategory?: any
  patientPhone?: string
  disablePatientPhone?: boolean
}

const RealRecipeItemInput = (
  {
    record,
    isShowPageChange = false,
    isShowAddcatalog = false,
    msfxFlag = false,
    searfhTcFlag = false,
    noSuffix,
    selectTag,
    noSetting,
    isRestrictUser,
    wbTag,
    type,
    category,
    storehouseId,
    normalGysName,
    filters = true,
    value,
    useSpecifiedBatch = false,
    ignoreStorage = false,
    includeAllTcm = false,
    onChange,
    onSelect,
    onItems,
    onBlur,
    autoFocus = false,
    onPressEnter,
    onKeyDown,
    style,
    disabled = false,
    insuranceCode,
    potionType,
    BScategory,
    categoryTag,
    scene,
    storehouseCategory,
    placeholder,
    patientPhone,
    disablePatientPhone = false,
  }: RecipeItemInputProps &
    Pick<InputProps, 'onBlur' | 'onPressEnter' | 'onKeyDown'>,
  ref: React.Ref<RecipeItemInputRef>
): ReactElement => {
  let viewportHeight = window.innerHeight;

  let isPaginationChanging = false

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const settings = useSelector(selectSettings)

  const autoChangePrice = useSelector(
    selectBooleanSetting(Settings.Recipe.AutoChangePrice)
  )
  const autoChangePriceAfter = useSelector(
    selectBooleanSetting(Settings.Recipe.AutoChangePriceAfter)
  )

  const inputRef = useRef<Input>(null)

  const actionRef = useRef<GlobalKeyboardAction>(null)

  const tenantId = useSelector(selectTenantId)

  const treatment = useSelector(selectTreatment)

  const [detail, setDetail] = useState<any>({})

  const [isMLVisible, setIsMLVisible] = useState(false)

  const [isVisible, setIsVisible] = useState(false)

  const [isFilterVisible, setIsFilterVisible] = useState(false)

  const [medicalType, setMedicalType] = useState<any>(1)

  const [items, setItems] = useState<Material[]>([])

  const [pager, setPager] = useState<Pager>(FirstPage)

  const [selectedRowId, setSelectedRowId] = useState('')

  const [loadingModalVisible, setLoadingModalVisible] = useState(false)

  const [isComposing, setIsComposing] = useState(false)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [inputFocus, setInputFocus] = useState(autoFocus || false)

  const [params, setParams] = useState<{ keyword: string; current: number; size?: number }>({
    keyword: '',
    current: 1,
    size: isShowPageChange ? Number(localStorage.getItem('recipeItemPageSize')) || 5 : 5
  })

  const [currentPage, setCurrentPage] = useState(isShowPageChange ? Number(localStorage.getItem('recipeItemPageSize')) || 5 : 5)

  const [queryStr, setQueryStr] = useState('')
  const [checkLoading, setCheckLoading] = useState(false)

  const normalGysNameFlag = localStorage.getItem('normalGysName')

  const [pageLoading, setPageLoading] = useState(false)

  useEffect(() => {
    if (!isModalVisible) {
      setDetail({})
    }
  }, [isModalVisible])

  useEffect(() => {
    if (selectTag) {
      inputRef.current?.focus()
    }
  }, [selectTag])

  const getType36 = () => {
    dispatch(
      getAcceptsType({
        type: '36',
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        dispatch(
          setSettings({
            [Settings.Recipe.AutoChangePrice]: res == 'true' ? true : false,
          })
        )
      })
      .catch(() => {
        setCheckLoading(false)
      })
      .finally(() => {
        setCheckLoading(false)
      })
  }
  const getType55 = () => {
    dispatch(
      getAcceptsType({
        type: '55',
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        dispatch(
          setSettings({
            [Settings.Recipe.AutoChangePriceAfter]:
              res == 'true' ? true : false,
          })
        )
      })
      .catch(() => {
        setCheckLoading(false)
      })
      .finally(() => {
        setCheckLoading(false)
      })
  }

  const complete = (keyword: string, current: number, size?: number) => {
    // 当keyword以'8'开头且长度>=20时，不调用搜索接口，交由onPressEnter处理
    if (keyword && keyword?.startsWith('8') && keyword.length >= 20) {
      reset()
      return
    }
    if (keyword) {
      if (searfhTcFlag) {
        if (keyword?.startsWith('.')) {
          // 0西药套餐;1中药套餐;2诊疗套餐;3颗粒剂套餐;4处置项目套餐;5检查套餐6输注套餐7治疗套餐8其他套餐 
          let categoryData = ''
          //(completionType 1药品2诊疗)
          // 西药方成药房
          if (category == 1) {
            categoryData = '0,2,4'
            // 中药方 //15中药贴敷方
          } else if (category == 3) {
            categoryData = '1'
            // 颗粒草药方
          } else if (category == 12) {
            categoryData = '3'
            // 输注方
          } else if (category == 14) {
            categoryData = '0,2,4'
            // 治疗方
          } else if (category == 4) {
            categoryData = '0,2'
            // 检查方
          } else if (category == 6) {
            categoryData = '5'
            // 处置项目
          } else if (category == 13) {
            categoryData = '2,4'
            // 其他
          } else if (category == 7) {
            categoryData = '0,1,2,3'
          }
          dispatch(
            getSetMealListAsync({
              name: keyword.startsWith('.') ? keyword.slice(1) : keyword,
              state: 1,
              current,
              size: size,
              category: categoryData,
              // onlyViewMyself: true,
            })
          )
            .then(unwrapResult)
            .then((v: any) => {
              const items = v?.records
              const pager = {
                current: v?.current || 1,
                size: v?.size || 5,
                total: v?.total,
              }
              setItems(items)
              onItems && onItems(items)
              setPager(pager)
              setIsVisible(true)
              if (items.length > 0) {
                setSelectedRowId(items[0].id)
              } else {
                setSelectedRowId('')
              }
            })
        } else {
          getData(keyword, current, size)
        }
      } else {
        if (inputFocus) {
          getData(keyword, current, size)
        }
      }
    } else {
      reset()
    }
  }

  const getData = (keyword: string, current: number, size?: number) => {
    let completionType = type
    if (
      type === ItemCompletionType.Auto ||
      type === ItemCompletionType.cureCheck
    ) {
      if (ignoreStorage) {
        completionType = ItemCompletionType.Material
      } else {
        completionType = ItemCompletionType.Inventory
      }
      // 处置项目
    } else if (type === ItemCompletionType.ZLCL) {
      if (ignoreStorage) {
        completionType = ItemCompletionType.ZLCLSFHLKC
      } else {
        completionType = ItemCompletionType.ZLCLSFZDPC
      }
    }
    if (potionType == 1) {
      //代煎处方，忽略库存搜索
      completionType = ItemCompletionType.Material
    }
    setPageLoading(true)
    dispatch(
      getRecipeItemCompletions({
        type: completionType,
        keyword,
        category,
        current,
        size,
        storehouseId,
        normalGysName: normalGysNameFlag == 'true' ? normalGysName : '',
        merge: !useSpecifiedBatch,
        includeAllTcm,
        insuranceCode,
        isFullMatch: 0,
        deadlineFlag: BScategory == 9 ? 1 : undefined,
        isWubi: wbTag?.codeName,
        isRestrictUser,
        storehouseCategory: storehouseCategory,
        phone: disablePatientPhone ? undefined : (patientPhone || treatment?.patientPhone),
      })
    )
      .then(unwrapResult)
      .then(({ items, pager }) => {
        setItems(items)
        onItems && onItems(items)
        setPager(pager)
        setIsVisible(true)
        if (items.length > 0) {
          setSelectedRowId(items[0].id)
        } else {
          setSelectedRowId('')
        }
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useTimeout(
    () => {
      complete(params.keyword, params.current, params.size)
    },
    50,
    [params, hisVersion, ignoreStorage]
  )

  const hasAutoSelected = useRef(false)

  useEffect(() => {
    if (
      !hasAutoSelected.current &&
      params.keyword?.length === 13 &&
      params.keyword.startsWith('69') &&
      items?.length === 1
    ) {
      hasAutoSelected.current = true
      // 自动选中后保持下拉框可见，让用户能看到是什么药
      if (onSelect) {
        onSelect(items[0], ignoreStorage)
        reset()
        // onPressEnter && onPressEnter(items[0] as any)
        // 不再调用 reset()，避免关闭下拉框
        setSelectedRowId(items[0].id)
      }
    }
  }, [items, params.keyword, onSelect, ignoreStorage])

  useEffect(() => {
    // 当 keyword 变化时重置标记，允许下次满足条件再次自动选择
    hasAutoSelected.current = false
  }, [params.keyword])

  useEffect(() => {
    if (!isComposing) {
      setParams({ keyword: queryStr, current: 1, size: isShowPageChange ? Number(localStorage.getItem('recipeItemPageSize')) || 5 : 5 })

    }
  }, [isComposing, queryStr])

  // ItemCompletionType.Treatment 诊疗
  const columns = params.keyword.startsWith('.') && searfhTcFlag ? RecipeItemColumnTC(theme) : potionType == 1 || ignoreStorage ||
    type === ItemCompletionType.Treatment || type === ItemCompletionType.Material ? (categoryTag == '1' ? RecipeItemColumnsSimple(theme,settings,type) : RecipeItemColumnsSimple(theme,settings,type)?.filter((item) => item.key != 'origin')) : useSpecifiedBatch
    ? (categoryTag == '7' ? RecipeItemColumnsWithBatchNo(theme, scene,settings,type) : RecipeItemColumnsWithBatchNo(theme, scene,settings,type)?.filter((item) => item.key != 'inboundDate')) : RecipeItemColumns(theme,settings,type)

  const menu = () => (
    <Menu>
      <Menu.Item onClick={() => {
        add(0)
      }}>
        新增药品
      </Menu.Item>
      <Menu.Item onClick={() => {

        add(1)
      }}>
        新增材料
      </Menu.Item>
      <Menu.Item onClick={() => {
        add(2)
      }}>
        新增器械
      </Menu.Item>
      <Menu.Item onClick={() => {
        add(4)
      }}>
        新增其他
      </Menu.Item>
    </Menu>
  )

  const add = (flag?: any) => {
    // 码上放心标志
    if (isShowAddcatalog) {
      setLoadingModalVisible(true)
      getAiMatchData(record)
    } else {
      setIsModalVisible(true)
    }
    setIsVisible(false)
    setMedicalType(flag)
    setIsMLVisible(false)
  }

  const getAiMatchData = (record: any) => {
    const dataList = [record?.msfxDrugInfo]
    dispatch(getAiMatchAsync(dataList))
      .then(unwrapResult)
      .then((res: any) => {
        setDetail(res?.[0] || {})
      })
  }

  const overlay = (
    <Col
     onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
    }}>
      <Table
        style={{ maxHeight: viewportHeight <= 900 ? '500px' : '', overflow: viewportHeight <= 900 ? 'auto' : '' }}
        loading={pageLoading}
        className={styles.table}
        columns={columns}
        dataSource={items}
        size='small'
        pagination={false}
        rowKey={(m) => m.id}
        bordered
        onRow={(m) => ({
          onClick: () => {
            if (onSelect) {
              onSelect(m, ignoreStorage)
              reset()
              onPressEnter && onPressEnter(m as any)
            }
          },
        })}
        rowSelection={{
          type: 'radio',
          selectedRowKeys: [selectedRowId],
          onChange: (ks) => setSelectedRowId(ks[0] as string),
        }}
        rowClassName={
          (record: any) => {
            // if (insuranceCode) {
            return record.hilistCode ? '' : styles.gray
            // } else {
            //   return ''
            // }
          }
        }
      />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', margin: '10px 10px' }} onClick={() => {
        isPaginationChanging = true
      }}>
        <Pagination
          pageSize={pager.size}
          current={pager.current}
          total={pager.total}
          size='small'
          showSizeChanger={false}
          pageSizeOptions={['5', '8', '10']}
          onChange={(current: number, size: number, e?: React.SyntheticEvent) => {
            isPaginationChanging = true
            setParams({ keyword: value || '', current, size: params?.size })
            inputRef.current?.focus()
          }}
        />
        {isShowPageChange ? <div style={{ marginLeft: 10 }}>
          <span style={{ marginRight: 10 }}>每页展示：</span>
          <span className={currentPage == 5 ? styles.selectPageSizeItemStyle : styles.pageSizeItemStyle} onClick={() => {
            setParams({ keyword: value || '', current: pager.current, size: 5 })
            setCurrentPage(5)
            localStorage.setItem('recipeItemPageSize', '5')
            inputRef.current?.focus()
          }}>5条</span>
          <span className={currentPage == 8 ? styles.selectPageSizeItemStyle : styles.pageSizeItemStyle} onClick={() => {
            setParams({ keyword: value || '', current: pager.current, size: 8 })
            setCurrentPage(8)
            inputRef.current?.focus()
            localStorage.setItem('recipeItemPageSize', '8')
          }}>8条</span>
          <span className={currentPage == 10 ? styles.selectPageSizeItemStyle : styles.pageSizeItemStyle} onClick={() => {
            setParams({ keyword: value || '', current: pager.current, size: 10 })
            setCurrentPage(10)
            inputRef.current?.focus()
            localStorage.setItem('recipeItemPageSize', '10')
          }}>10条</span>
        </div> : <></>}
        {isShowAddcatalog || categoryTag == '1' ? <>
          <div style={{ position: 'absolute', right: '10px' }}>
            <span>没有找到商品？</span>
            <Dropdown
              overlay={menu()}
              trigger={['click']}
              visible={isMLVisible}
              onVisibleChange={((v) => {
                setIsMLVisible(v)
              })}>
              <span style={{ color: '#027AFF', cursor: 'pointer' }}
                onClick={(e) => {
                  setIsMLVisible(true)
                }}
              >新增目录</span>
            </Dropdown>
          </div>
        </> : <></>}
      </div>
      {isShowAddcatalog ?
        <div className={styles.tooltipContainer}>
          <Tooltip placement="bottom" title={<span>码上放心发货单商品：${record?.name} ${record?.displaySpec}</span>} >
            <div style={{ maxWidth: '700px', padding: '6px 10px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>码上放心发货单商品：{record?.name} {record?.displaySpec}</div>
          </Tooltip>
        </div> : <></>
      }
    </Col >
  )
  const filter = (
    <Row>
      <GlobalKeyboardAction
        ref={actionRef}
        manually
        onEscPress={() => setIsFilterVisible(false)}
      />
      <Col
        style={{
          padding: '10px 20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
        }}
      >
        <Form.Item label='是否指定批次'>
          <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            checked={useSpecifiedBatch}
            onClick={(_, e) => e.stopPropagation()}
            onChange={(v) => {
              const [k1, k2] =
                category === RecipeCategory.Tcm ||
                  category === RecipeCategory.TcmGranules
                  ? [
                    Settings.Recipe.TcmUseSpecifiedBatch,
                    Settings.Recipe.TcmIgnoreStorage,
                  ]
                  : [
                    Settings.Recipe.UseSpecifiedBatch,
                    Settings.Recipe.IgnoreStorage,
                  ]
              dispatch(
                setSettings({
                  [k1]: v,
                })
              )
              if (v) {
                dispatch(
                  setSettings({
                    [k2]: false,
                  })
                )
              }
            }}
            style={{
              backgroundColor: useSpecifiedBatch ? theme.s : theme.wsu,
            }}
          />
        </Form.Item>
        <Form.Item label='是否忽略库存'>
          <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            checked={ignoreStorage}
            onClick={(_, e) => e.stopPropagation()}
            onChange={(v) => {
              const [k1, k2] =
                category === RecipeCategory.Tcm ||
                  category === RecipeCategory.TcmGranules
                  ? [
                    Settings.Recipe.TcmUseSpecifiedBatch,
                    Settings.Recipe.TcmIgnoreStorage,
                  ]
                  : [
                    Settings.Recipe.UseSpecifiedBatch,
                    Settings.Recipe.IgnoreStorage,
                  ]
              dispatch(
                setSettings({
                  [k2]: v,
                })
              )
              if (v) {
                dispatch(
                  setSettings({
                    [k1]: false,
                  })
                )
              }
            }}
            style={{
              backgroundColor: ignoreStorage ? theme.s : theme.wsu,
            }}
          />
        </Form.Item>
        <div>自动计算天数：</div>
        <Form.Item label=''>
          <Checkbox
            onChange={(v: any) => {
              setCheckLoading(true)
              const params: any = [
                {
                  type: '36',
                  value: v?.target?.checked,
                },
              ]
              dispatch(getSaveSomeFunctions({ functionList: params }))
                .then(unwrapResult)
                .then((res: any) => {
                  getType36()
                })
                .catch(() => {
                  setCheckLoading(false)
                })
            }}
            checked={autoChangePrice}
            style={{
              margin: '10px 0',
              cursor: checkLoading ? 'wait' : 'pointer',
            }}
          >
            保存前
          </Checkbox>
          <Checkbox
            onChange={(v: any) => {
              setCheckLoading(true)
              const params: any = [
                {
                  type: '55',
                  value: v?.target?.checked,
                },
              ]
              dispatch(getSaveSomeFunctions({ functionList: params }))
                .then(unwrapResult)
                .then((res: any) => {
                  getType55()
                })
                .catch(() => {
                  setCheckLoading(false)
                })
            }}
            checked={autoChangePriceAfter}
            style={{
              margin: '10px 0',
              cursor: checkLoading ? 'wait' : 'pointer',
            }}
          >
            保存后
          </Checkbox>
          {/* <Switch
            checkedChildren='是'
            unCheckedChildren='否'
            checked={autoChangePrice}
            onClick={(_, e) => e.stopPropagation()}
           
            style={{
              backgroundColor: autoChangePrice ? theme.s : theme.wsu,
            }}
          /> */}
        </Form.Item>

        <Button
          type='primary'
          onClick={() => {
            setIsFilterVisible(false)
          }}
        >
          关闭(Esc)
        </Button>
      </Col >
    </Row >
  )

  window.addEventListener('resize', () => {
    viewportHeight = window.innerHeight;
  })

  useEffect(() => {
    if (isFilterVisible) {
      actionRef.current?.install()
    } else {
      actionRef.current?.uninstall()
    }
  }, [isFilterVisible])

  useEffect(() => {
    if (value) {
      setParams({ keyword: value || '', current: pager.current, size: params.size })
    }
  }, [useSpecifiedBatch, ignoreStorage])

  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus()
    },
    select: () => {
      inputRef.current?.select()
    },
  }))

  const reset = () => {
    setItems([])
    setPager(FirstPage)
    setSelectedRowId('')
    setIsVisible(false)
  }

  return (
    <>
      <Dropdown
        overlay={overlay}
        disabled={disabled}
        trigger={[]}
        visible={isVisible && (params.keyword?.length > 0 as any) || isMLVisible && (params.keyword?.length > 0 as any)}
        // visible={isVisible && items.length > 0}
        onVisibleChange={(v) => {
          setIsVisible(v)
        }}
        placement={'bottomLeft'}
      >
        <Input
          ref={inputRef}
          autoFocus={autoFocus}
          value={value}
          style={style}
          disabled={disabled}
          placeholder={placeholder}
          suffix={
            noSuffix ||
              settings[Checks.Lkcky] ||
              noSetting ? undefined : filters &&
                type !== ItemCompletionType.Treatment ? (
              <Dropdown
                trigger={['click']}
                overlay={filter}
                visible={isFilterVisible}
                onVisibleChange={(v) => {
                  setIsFilterVisible(v)
                }}
              >
                <SettingFilled
                  onClick={() => setIsFilterVisible(!isFilterVisible)}
                />
              </Dropdown>
            ) : undefined
          }
          onClick={() => {
            setParams({ keyword: value || '', current: 1, size: params.size })
          }}
          onFocus={() => {
            setIsVisible(true)
            setInputFocus(true)
          }}
          onBlur={async (e: any) => {
            onBlur && onBlur(e)
            await sleep(200)

            // 👇 只有真正点击外部才关闭
            const isClickInside = e.relatedTarget?.closest('.ant-dropdown')
            if (!isClickInside) {
              setIsVisible(false)
            }

            setInputFocus(false)
          }}
          onCompositionStart={() => {
            setIsComposing(true)
          }}
          onCompositionEnd={(e) => {
            setIsComposing(false)
            setParams({ keyword: e.data, current: 1, size: params.size })
          }}
          onChange={(e) => {
            setQueryStr(e.target.value)
            // if (!isComposing) {
            //   setParams({ keyword: e.target.value, current: 1 })
            // }
            if (onChange) {
              onChange(e.target.value)
            }
          }}
          onKeyDown={(event) => {
            onKeyDown && onKeyDown(event)
            if (!selectedRowId) {
              return
            }
            let index = items.findIndex((m) => m.id === selectedRowId)
            const oneId = items?.[0]?.id
            const lastId = items?.[items?.length - 1]?.id
            switch (event.key) {
              case 'ArrowDown':
                // index = index + 1
                index = lastId == selectedRowId ? 0 : index + 1
                break
              case 'ArrowUp':
                index =
                  oneId == selectedRowId ? index + (items?.length - 1) : index - 1
                break
              case 'ArrowRight':
                if (pager.current * pager.size < pager.total) {
                  setParams({ keyword: value || '', current: pager.current + 1, size: params.size })
                }
                break
              case 'ArrowLeft':
                if (pager.current > 1) {
                  setParams({ keyword: value || '', current: pager.current - 1, size: params.size })
                }
                break
            }
            if (index >= 0 && index < items.length) {
              setSelectedRowId(items[index].id)
            }
          }}
          onPressEnter={(e) => {
            onPressEnter && onPressEnter(e)
            if (!selectedRowId || !onSelect) {
              return
            }
            const item = items.find((m) => m.id === selectedRowId)
            if (item) {
              onSelect(item, ignoreStorage)
              reset()
            }
          }}
        />
      </Dropdown>
      <AddCatalogueModal
        details={categoryTag == '1' ? {} : detail}
        isModalVisible={isModalVisible}
        onOk={(() => {
          setIsModalVisible(false)
        })}
        onCancel={(() => {
          setIsModalVisible(false)
        })}
        medicalType={medicalType}
        batch={(t: any) => {
          if (t) {
            // 购入入库
            if (categoryTag == '1') {
              const data = {
                ...t,
                packSpec: t?.packSpec ? t?.packSpec : '',
                backFillStockPrice: t?.stockPrice,
                backFillRetailPrice: t?.retailPrice,
                backFillSplitPrice: t?.splitPrice,
                id: t?.materialsCatalogId,
              }
              onSelect && onSelect(data, ignoreStorage)
              reset()
              onPressEnter && onPressEnter(data as any)
            } else {
              // 码上放心
              onSelect && onSelect({
                ...record,
                ...t,
                packSpec: t?.packSpec ? t?.packSpec : '',
                backFillStockPrice: t?.stockPrice,
                localProdName: t?.name,
                backFillRetailPrice: t?.retailPrice,
                backFillSplitPrice: t?.splitPrice,
                totalPrice: categoryTag == '1' ? (t?.count || 0) * t?.retailPrice : (record?.count || 0) * t?.retailPrice,
                localDisplaySpec: t?.packSpec + "/" + t?.accountUnit + "/" + t?.doseCategory + "/" + t?.tenantSupplierName,
                matchedFlag: t?.no ? true : t?.matchedFlag,
                id: t?.materialsCatalogId,
              }, ignoreStorage)
              reset()
            }
          } else {
            reset()
          }
        }}
      ></AddCatalogueModal>
      <LoadingModal
        details={detail}
        isModalVisible={loadingModalVisible}
        onOk={(() => {
          setLoadingModalVisible(false)
          setIsModalVisible(true)
        })}
        onCancel={(() => {
          setLoadingModalVisible(false)

        })}
      ></LoadingModal>
    </>
  )
}

export const RecipeItemInput = forwardRef(RealRecipeItemInput)
